/** My account: who is signed in on this device, the device's sync state, and locking it. */
import { ASSIST_VERSION } from '@assist/core';
import { app } from '../controller.js';
import { useApp } from '../hooks.js';
import { t } from '../i18n.js';

export function Me() {
  const a = useApp();
  const u = a.session?.user;
  if (!u) return null;
  const st = a.status;
  const rows: Array<[string, string]> = [
    [t.fullName, u.fullName],
    [t.username, u.username],
    [t.roleLabel, t.roleName[u.role] ?? u.role],
    [t.facility, u.facilityName],
    [t.toSend, String(st?.outbox ?? 0)],
    [t.lastSyncLabel, st?.lastSyncAt ? new Date(st.lastSyncAt).toLocaleString() : t.never],
    [t.versionLabel, ASSIST_VERSION],
  ];
  return (
    <div class="card">
      <h3>{t.navMe}</h3>
      <div class="rec">
        <div class="rec-g">
          {rows.map(([k, v]) => (
            <div class="rec-f" key={k}>
              <span class="rec-l">{k}</span>
              <span class="rec-v">{v}</span>
            </div>
          ))}
        </div>
      </div>
      <div class="actions left">
        <button type="button" class="sec" onClick={() => void app.syncNow()}>
          {t.syncNow}
        </button>
        {st?.failed ? (
          <a class="nav" href="#/failed">
            {t.failedN(st.failed)}
          </a>
        ) : null}
        <button type="button" class="act" onClick={() => app.lock()}>
          {t.lockDevice}
        </button>
      </div>
      <p class="muted">{t.lockHelp}</p>
    </div>
  );
}
